import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/download/head_icon.jpg'
import _imports_1 from '@/assets/download/flashThunder.svg'
import _imports_2 from '@/assets/download/image.png'
import _imports_3 from '@/assets/download/phone.png'
import _imports_4 from '@/assets/download/tablet.png'
import _imports_5 from '@/assets/download/flag.png'
import _imports_6 from '@/assets/download/brazil.png'


const _hoisted_1 = { style: {"background":"#fff"} }
const _hoisted_2 = { style: {"padding-top":"5px"} }
const _hoisted_3 = { style: {"display":"flex","justify-content":"flex-start","align-items":"center","color":"#000"} }
const _hoisted_4 = { style: {"margin":"5px 0px","font-size":"28px","font-weight":"500"} }
const _hoisted_5 = { style: {"display":"flex","justify-content":"flex-start","align-items":"center"} }
const _hoisted_6 = { style: {"color":"#01875f","font-weight":"600","font-size":"16px","padding-bottom":"5px"} }
const _hoisted_7 = { style: {"display":"flex","justify-content":"flex-start","align-items":"center"} }
const _hoisted_8 = { style: {"color":"#5f6368","font-size":"13px"} }
const _hoisted_9 = { style: {"display":"flex","justify-content":"center","align-items":"center","padding":"15px 30px 15px 30px"} }
const _hoisted_10 = { style: {"color":"#ffe336","padding-bottom":"2px","align-items":"center","display":"flex","justify-content":"center","font-size":"14px"} }
const _hoisted_11 = { style: {"color":"#fff","font-size":"12px","margin-bottom":"3px"} }
const _hoisted_12 = { style: {"display":"flex","justify-content":"center","align-items":"center","padding":"15px 10px 15px 10px"} }
const _hoisted_13 = { style: {"color":"#01875f","font-size":"15px","margin-left":"6px"} }
const _hoisted_14 = { style: {"display":"flex","justify-content":"center","align-items":"center","padding":"5px 10px 15px 10px"} }
const _hoisted_15 = { style: {"color":"#01875f","font-size":"15px","margin-left":"6px"} }
const _hoisted_16 = {
  class: "textContent",
  style: {"padding":"25px 18px 1px 18px"}
}
const _hoisted_17 = { style: {"font-size":"15px","color":"#000"} }
const _hoisted_18 = { style: {"font-weight":"400","color":"#5f6368","font-size":"13px","margin":"0px"} }
const _hoisted_19 = {
  class: "textContent",
  style: {"padding":"30px 18px 1px 18px"}
}
const _hoisted_20 = { style: {"border":"1px solid #dadce0","border-radius":"10px","margin-top":"5px","padding-bottom":"10px"} }
const _hoisted_21 = { style: {"margin":"20px 0px 0px 30px"} }
const _hoisted_22 = { style: {"color":"#01875f","font-size":"14px"} }
const _hoisted_23 = {
  class: "textContent",
  style: {"padding":"30px 18px 1px 18px"}
}
const _hoisted_24 = { style: {"display":"flex","justify-content":"flex-start","align-items":"center"} }
const _hoisted_25 = { style: {"font-size":"18px","font-weight":"600","color":"#000"} }
const _hoisted_26 = { style: {"display":"flex","justify-content":"flex-end","align-items":"center","padding-right":"5px"} }
const _hoisted_27 = { style: {"display":"flex","justify-content":"flex-start","align-items":"center","padding-top":"7px","color":"#5f6368"} }
const _hoisted_28 = { style: {"font-size":"13px","font-weight":"400","margin-right":"5px"} }
const _hoisted_29 = { style: {"display":"flex","justify-content":"flex-start","align-items":"center","padding-top":"10px","color":"#5f6368"} }
const _hoisted_30 = { style: {"display":"flex","justify-content":"flex-start","flex-direction":"column","margin-top":"-20px"} }
const _hoisted_31 = { style: {"display":"flex","justify-content":"flex-start","flex-direction":"row"} }
const _hoisted_32 = { style: {"font-size":"14px","font-weight":"400","color":"#5f6368","margin-top":"3px"} }
const _hoisted_33 = { style: {"padding":"30px 0px 1px 0px"} }
const _hoisted_34 = { style: {"padding":"30px 0px 1px 0px"} }
const _hoisted_35 = { style: {"font-weight":"600","font-size":"14px","color":"#01875f","padding-top":"10px"} }
const _hoisted_36 = { style: {"padding":"30px 0px 1px 0px"} }
const _hoisted_37 = { style: {"font-size":"20px","font-weight":"600","color":"#000"} }
const _hoisted_38 = { style: {"color":"rgb(95, 99, 104)","font-size":"16px","font-weight":"100"} }
const _hoisted_39 = { style: {"margin":"15px 0 0 0"} }
const _hoisted_40 = { style: {"margin":"3px 0 0 0"} }
const _hoisted_41 = { style: {"margin":"15px 0 0 0"} }
const _hoisted_42 = { style: {"margin":"15px 0 0 0"} }
const _hoisted_43 = { style: {"padding":"15px 0px 0px 0px"} }
const _hoisted_44 = { style: {"display":"flex","justify-content":"flex-start","align-items":"center"} }
const _hoisted_45 = { style: {"font-size":"20px","font-weight":"600","color":"#000","padding":"5px 0px"} }
const _hoisted_46 = { style: {"display":"flex","justify-content":"flex-end","align-items":"center","padding-right":"5px"} }
const _hoisted_47 = { style: {"padding":"30px 0px 1px 0px"} }
const _hoisted_48 = { style: {"padding":"10px 0px 1px 0px"} }
const _hoisted_49 = { style: {"padding-left":"10px","display":"flex","justify-content":"flex-start","color":"#000"} }
const _hoisted_50 = { style: {"display":"flex","flex-direction":"column","line-height":"30px","color":"#5f6368"} }
const _hoisted_51 = { style: {"font-size":"14px","font-weight":"600"} }
const _hoisted_52 = { style: {"font-size":"14px","font-weight":"400"} }
const _hoisted_53 = { style: {"font-size":"14px","font-weight":"400"} }
const _hoisted_54 = { style: {"font-size":"14px","font-weight":"400"} }
const _hoisted_55 = { style: {"font-size":"14px","font-weight":"400"} }
const _hoisted_56 = { style: {"font-size":"14px","font-weight":"400"} }
const _hoisted_57 = { style: {"padding":"60px 0px 1px 0px","display":"flex","justify-content":"flex-start","color":"#5f6368"} }
const _hoisted_58 = { style: {"padding":"10px 0px 1px 0px","display":"flex","justify-content":"flex-start","color":"#5f6368"} }
const _hoisted_59 = { style: {"padding":"20px 0px 60px 0px","display":"flex","justify-content":"flex-start","color":"#5f6368"} }

import { ref } from "vue";
import AppData from "./components/AppData.vue";
import ArrowContent from "./components/ArrowContent.vue";
import SecurityList from "./components/SecurityList.vue";
import RateBar from "./components/RateBar.vue";
import UserComment from "./components/UserComment.vue";
import SimilarGame from "./components/SimilarGame.vue";
import DownloadHeader from "./components/DownloadHeader.vue";
import DownloadFooter from "./components/DownloadFooter.vue";
import { onMounted } from "vue";
import { getPWADomainInfo } from "@/api/common";



export default /*@__PURE__*/_defineComponent({
  __name: 'DownloadView',
  setup(__props) {

const updatedDate = ref('Feb 10,2025')

const users = ref([
    { img: require('@/assets/download/coment1.png') },
    { img: require('@/assets/download/coment2.png') },
    { img: require('@/assets/download/coment3.png') }
])

const games = ref([
    { img: require('@/assets/download/similarOne.png') },
    { img: require('@/assets/download/similarTwo.png') },
    { img: require('@/assets/download/similarThree.png') },
    { img: require('@/assets/download/similarFour.png') },
    { img: require('@/assets/download/similarFive.png') },
    { img: require('@/assets/download/similarSix.png') }
])
const deferredPrompt = ref<Event | null>(null);
const promotion = ref(false);
const installApp = async () => {
    if (deferredPrompt.value && 'prompt' in deferredPrompt.value) {
        const promptEvent = deferredPrompt.value as any
        promptEvent.prompt();
        deferredPrompt.value = null;
    }
}

// PWA install prompt
window.addEventListener('beforeinstallprompt', (e: Event) => {
    e.preventDefault()
    deferredPrompt.value = e
});

const saveTokenFromQuery = () => {
    let params: URLSearchParams;

    if (window.location.search) {
        params = new URLSearchParams(window.location.search);
    } else if (window.location.hash.includes("?")) {
        const hashQuery = window.location.hash.split("?")[1];
        params = new URLSearchParams(hashQuery);
    } else {
        return;
    }

    const token = params.get("token");
    const clientId = params.get("clientId");
    const tenantId = params.get("tenantId");

    if (token) localStorage.setItem("token", token);
    if (clientId) localStorage.setItem("clientId", clientId);
    if (tenantId) localStorage.setItem("tenantId", tenantId);

    // 🔹 Clean the URL right after saving (so it won’t restore again)
    cleanURL();
};

const cleanURL = () => {
    const baseUrl = window.location.origin + window.location.pathname;

    // Keep only the hash route, strip query params after '?'
    const cleanHash = window.location.hash.split("?")[0] || "";

    // Replace URL without reloading
    window.history.replaceState({}, document.title, baseUrl + cleanHash);
};

onMounted(() => {

    saveTokenFromQuery()
})

return (_ctx: any,_cache: any) => {
  const _component_van_col = _resolveComponent("van-col")!
  const _component_van_row = _resolveComponent("van-row")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_tag = _resolveComponent("van-tag")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(DownloadHeader),
      _createVNode(_component_van_row, { style: {"margin-top":"60px","align-items":"center"} }, {
        default: _withCtx(() => [
          _createVNode(_component_van_col, { span: "6" }, {
            default: _withCtx(() => _cache[0] || (_cache[0] = [
              _createElementVNode("div", { style: {"display":"flex","justify-content":"center","align-items":"center","padding":"15px 2px"} }, [
                _createElementVNode("img", {
                  style: {"height":"65px","width":"65px","object-fit":"contain","border-radius":"15px","border":"0.5px solid #000"},
                  src: _imports_0
                })
              ], -1)
            ])),
            _: 1
          }),
          _createVNode(_component_van_col, {
            span: "18",
            style: {"padding-left":"5px"}
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('donwload.appName')), 1)
              ]),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t('donwload.title')), 1)
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$t('donwload.subtitle')), 1)
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(AppData),
      _createVNode(_component_van_row, { style: {"margin-top":"5px"} }, {
        default: _withCtx(() => [
          _createVNode(_component_van_col, { span: "24" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_van_button, {
                  class: "dialog_button",
                  onClick: installApp,
                  style: {"border-radius":"10px","background-color":"#01875f","height":"55px","padding":"10px","display":"flex","flex-direction":"column","align-items":"center"}
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_10, [
                      _cache[1] || (_cache[1] = _createElementVNode("img", {
                        style: {"height":"20px","width":"20px"},
                        src: _imports_1
                      }, null, -1)),
                      _createTextVNode(" " + _toDisplayString(_ctx.$t('donwload.rapidDonwload')), 1)
                    ]),
                    _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.$t('download.withinSec')), 1)
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_van_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_van_col, { span: "12" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_12, [
                _createVNode(_component_van_icon, {
                  name: "share",
                  size: "25",
                  color: "#01875f"
                }),
                _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.$t('download.share')), 1)
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_van_col, { span: "12" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_14, [
                _createVNode(_component_van_icon, {
                  name: "bookmark",
                  size: "25",
                  color: "#01875f"
                }),
                _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.$t('download.wishList')), 1)
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_van_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_van_col, { span: "24" }, {
            default: _withCtx(() => _cache[2] || (_cache[2] = [
              _createElementVNode("div", { style: {"height":"200px","display":"flex","justify-content":"center","align-items":"center","padding":"5px 18px 5px 18px"} }, [
                _createElementVNode("img", {
                  style: {"height":"100%","width":"100%","object-fit":"fill","border-radius":"10px"},
                  src: _imports_2
                })
              ], -1)
            ])),
            _: 1
          })
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_16, [
        _createVNode(ArrowContent, {
          heading: _ctx.$t('download.aboutGame'),
          content: _ctx.$t('download.appDataContent'),
          htmlValue: true
        }, null, 8, ["heading", "content"]),
        _createVNode(_component_van_row, { style: {"margin-top":"0px"} }, {
          default: _withCtx(() => [
            _createVNode(_component_van_col, { span: 24 }, {
              default: _withCtx(() => [
                _createElementVNode("p", _hoisted_17, _toDisplayString(_ctx.$t('donwload.updatedOn')), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_van_row, { style: {"margin-top":"3px"} }, {
          default: _withCtx(() => [
            _createVNode(_component_van_col, { span: 24 }, {
              default: _withCtx(() => [
                _createElementVNode("p", _hoisted_18, _toDisplayString(updatedDate.value), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _createVNode(_component_van_row, { style: {"margin-top":"3px","padding":"25px 0px 0px 18px","font-weight":"600"} }, {
        default: _withCtx(() => [
          _createVNode(_component_van_col, { span: 8 }, {
            default: _withCtx(() => [
              _createVNode(_component_van_tag, {
                class: "tagList",
                plain: true,
                round: "",
                type: "primary",
                color: "#5f6368",
                size: "large"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('download.casino')), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_van_col, { span: 2 }),
          _createVNode(_component_van_col, { span: 8 }, {
            default: _withCtx(() => [
              _createVNode(_component_van_tag, {
                class: "tagList",
                plain: true,
                round: "",
                type: "primary",
                color: "#5f6368",
                size: "large"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('download.slotMach')), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_19, [
        _createVNode(ArrowContent, {
          style: {"height":"40px"},
          heading: _ctx.$t('download.dataSecurity'),
          content: _ctx.$t('download.appSecurity')
        }, null, 8, ["heading", "content"]),
        _createElementVNode("div", _hoisted_20, [
          _createVNode(SecurityList, { ref: "securityListRef" }, null, 512),
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.$t('lottery.moreDetails')), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_23, [
        _createVNode(_component_van_row, { style: {"align-items":"center"} }, {
          default: _withCtx(() => [
            _createVNode(_component_van_col, { span: "16" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.$t('donwload.ratingAndReview')), 1)
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_van_col, { span: "8" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_26, [
                  _createVNode(_component_van_icon, {
                    name: "arrow",
                    size: "15",
                    color: "#5f6368"
                  })
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_van_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_van_col, { span: "16" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.$t('donwload.vefied')), 1)
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_van_col, { span: 4 }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_29, [
                  _createVNode(_component_van_icon, {
                    name: "info-o",
                    size: "14",
                    color: "#5f6368"
                  })
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_van_row, { style: {"margin-top":"3px","padding":"30px 0px 30px 0px","font-weight":"500"} }, {
          default: _withCtx(() => [
            _createVNode(_component_van_col, { span: 8 }, {
              default: _withCtx(() => [
                _createVNode(_component_van_tag, {
                  round: "",
                  plain: true,
                  class: "tagList",
                  text: _ctx.$t('download.telephone'),
                  size: "large",
                  borderColor: "transparent",
                  bgColor: "#e6f3ef",
                  color: "#01875f",
                  shape: "circle"
                }, {
                  default: _withCtx(() => [
                    _cache[3] || (_cache[3] = _createElementVNode("img", {
                      src: _imports_3,
                      alt: "icon",
                      style: {"height":"16px","width":"16px","margin-right":"5px"}
                    }, null, -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('download.telephone')), 1)
                  ]),
                  _: 1
                }, 8, ["text"])
              ]),
              _: 1
            }),
            _createVNode(_component_van_col, { span: 2 }),
            _createVNode(_component_van_col, { span: 8 }, {
              default: _withCtx(() => [
                _createVNode(_component_van_tag, {
                  round: "",
                  plain: true,
                  class: "tagList",
                  size: "large",
                  borderColor: "#dadce0",
                  color: "#5f6368",
                  shape: "circle"
                }, {
                  default: _withCtx(() => [
                    _cache[4] || (_cache[4] = _createElementVNode("img", {
                      src: _imports_4,
                      alt: "icon",
                      style: {"height":"16px","width":"16px","margin-right":"5px","filter":"brightness(0.5)"}
                    }, null, -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('download.tablet')), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_van_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_van_col, { span: "10" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_30, [
                  _cache[5] || (_cache[5] = _createElementVNode("span", { style: {"font-size":"50px","font-weight":"400","color":"#202124"} }, "4.9", -1)),
                  _createElementVNode("div", _hoisted_31, [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (i) => {
                      return _createVNode(_component_van_icon, {
                        name: "star",
                        style: {"padding":"2px"},
                        key: i,
                        size: "14",
                        color: "#01875f"
                      })
                    }), 64))
                  ]),
                  _createElementVNode("span", _hoisted_32, _toDisplayString(_ctx.$t('download.reviewCount')), 1)
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_van_col, { span: 14 }, {
              default: _withCtx(() => [
                _createVNode(RateBar, {
                  rateNum: 5,
                  percentage: 92
                }),
                _createVNode(RateBar, {
                  rateNum: 4,
                  percentage: 2
                }),
                _createVNode(RateBar, {
                  rateNum: 3,
                  percentage: 1
                }),
                _createVNode(RateBar, {
                  rateNum: 2,
                  percentage: 2
                }),
                _createVNode(RateBar, {
                  rateNum: 1,
                  percentage: 2
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_33, [
          _createVNode(UserComment, {
            img: users.value[0].img,
            name: "Lara Liras",
            comment: _ctx.$t('download.commentOne'),
            commentDate: _ctx.$t('download.commentDateOne'),
            redivCount: 52
          }, null, 8, ["img", "comment", "commentDate"]),
          _createVNode(UserComment, {
            img: users.value[1].img,
            name: "Angelita Da Silva",
            comment: _ctx.$t('download.commentTwo'),
            commentDate: _ctx.$t('download.commentDateTwo'),
            redivCount: 22
          }, null, 8, ["img", "comment", "commentDate"]),
          _createVNode(UserComment, {
            img: users.value[2].img,
            name: "Rubens Vieira dos Santos",
            comment: _ctx.$t('download.commentThree'),
            commentDate: _ctx.$t('download.commentDateThree'),
            redivCount: 20
          }, null, 8, ["img", "comment", "commentDate"])
        ]),
        _createElementVNode("div", _hoisted_34, [
          _createElementVNode("span", _hoisted_35, _toDisplayString(_ctx.$t('download.seeAllReview')), 1)
        ]),
        _createElementVNode("div", _hoisted_36, [
          _createElementVNode("span", _hoisted_37, _toDisplayString(_ctx.$t('donwload.whatsNew')), 1),
          _createElementVNode("div", _hoisted_38, [
            _createElementVNode("p", _hoisted_39, _toDisplayString(_ctx.$t('download.helloFan')), 1),
            _createElementVNode("p", _hoisted_40, _toDisplayString(_ctx.$t('download.newUpdate')), 1),
            _createElementVNode("p", _hoisted_41, _toDisplayString(_ctx.$t('download.perFormUpdate')), 1),
            _createElementVNode("p", _hoisted_42, _toDisplayString(_ctx.$t('download.enjoy')), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_43, [
          _createVNode(_component_van_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_van_col, { span: "16" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_44, [
                    _createElementVNode("span", _hoisted_45, _toDisplayString(_ctx.$t('download.similarGame')), 1)
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_van_col, { span: "8" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_46, [
                    _createVNode(_component_van_icon, {
                      style: {"padding":"10px 0px"},
                      size: "15",
                      color: "#5f6368",
                      name: "arrow",
                      bold: true
                    })
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_47, [
          _createVNode(_component_van_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_van_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(SimilarGame, {
                    img: games.value[0].img,
                    gameName: "Cash Craze:",
                    subHeading: "Casual Joy Ga",
                    rate: 4.5
                  }, null, 8, ["img"])
                ]),
                _: 1
              }),
              _createVNode(_component_van_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(SimilarGame, {
                    img: games.value[1].img,
                    gameName: "Charge Buffa",
                    subHeading: "FUFAFA TECHN",
                    rate: 4.5
                  }, null, 8, ["img"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_van_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_van_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(SimilarGame, {
                    img: games.value[2].img,
                    gameName: "Jackpot Mag",
                    subHeading: "Big Fish Game",
                    rate: 2.6
                  }, null, 8, ["img"])
                ]),
                _: 1
              }),
              _createVNode(_component_van_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(SimilarGame, {
                    img: games.value[3].img,
                    gameName: "Diamond Slot",
                    subHeading: "International G",
                    rate: 3.9
                  }, null, 8, ["img"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_van_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_van_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(SimilarGame, {
                    img: games.value[4].img,
                    gameName: "Bônus Bingo",
                    subHeading: "FUFAFA TECHN",
                    rate: 4.4
                  }, null, 8, ["img"])
                ]),
                _: 1
              }),
              _createVNode(_component_van_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(SimilarGame, {
                    img: games.value[5].img,
                    gameName: "Infinity Slots",
                    subHeading: "Murka Games",
                    rate: 4.5
                  }, null, 8, ["img"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_48, [
          _createVNode(_component_van_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_van_col, { span: 2 }, {
                default: _withCtx(() => _cache[6] || (_cache[6] = [
                  _createElementVNode("img", {
                    style: {"height":"20px","width":"20px","object-fit":"cover","border-radius":"10px"},
                    src: _imports_5
                  }, null, -1)
                ])),
                _: 1
              }),
              _createVNode(_component_van_col, { span: 20 }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_49, _toDisplayString(_ctx.$t('download.flagMsg')), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _cache[8] || (_cache[8] = _createElementVNode("div", { style: {"border":"1px solid #e8eaed","width":"100%","margin":"50px 0px"} }, null, -1)),
        _createElementVNode("div", _hoisted_50, [
          _createElementVNode("span", _hoisted_51, _toDisplayString(_ctx.$t('download.googlePlay')), 1),
          _createElementVNode("span", _hoisted_52, _toDisplayString(_ctx.$t('download.playPass')), 1),
          _createElementVNode("span", _hoisted_53, _toDisplayString(_ctx.$t('download.playPoint')), 1),
          _createElementVNode("span", _hoisted_54, _toDisplayString(_ctx.$t('download.gift')), 1),
          _createElementVNode("span", _hoisted_55, _toDisplayString(_ctx.$t('download.rescue')), 1),
          _createElementVNode("span", _hoisted_56, _toDisplayString(_ctx.$t('download.refund')), 1)
        ]),
        _createElementVNode("div", _hoisted_57, [
          _createVNode(_component_van_row, { style: {"width":"100%"} }, {
            default: _withCtx(() => [
              _createVNode(_component_van_col, {
                span: 8,
                style: {"width":"100%","padding":"10px 0"}
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t('download.terms')), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_van_col, {
                span: 12,
                style: {"width":"100%","padding":"10px 0"}
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t('download.privacy')), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_van_col, {
                span: 8,
                style: {"width":"100%","padding":"10px 0"}
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t('download.about')), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_van_col, {
                span: 12,
                style: {"width":"100%","padding":"10px 0"}
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t('download.developer')), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_van_col, {
                span: 8,
                style: {"width":"100%","padding":"10px 0"}
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t('download.store')), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_van_col, {
                span: 16,
                style: {"width":"100%","padding":"10px 0"}
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t('download.allPrice')), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_58, [
          _createVNode(_component_van_row, { style: {"width":"100%"} })
        ]),
        _createElementVNode("div", _hoisted_59, [
          _createVNode(_component_van_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_van_col, {
                span: 6,
                style: {"padding":"5px"}
              }, {
                default: _withCtx(() => _cache[7] || (_cache[7] = [
                  _createElementVNode("img", {
                    style: {"height":"18px","width":"24px","object-fit":"cover"},
                    src: _imports_6
                  }, null, -1)
                ])),
                _: 1
              }),
              _createVNode(_component_van_col, {
                span: 18,
                style: {"padding":"5px","width":"200px"}
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t('download.bottomNotice')), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _createVNode(DownloadFooter)
  ]))
}
}

})